import { Button } from '@mui/material';
import { useTranslation } from '@/feature/lang';
import Translate from '../Translate';
import type { EmptyProps } from './Empty';
import Empty from './Empty';

interface ErrorProps extends EmptyProps {
  retry?: () => void;
}

const Error = ({ retry, ...other }: ErrorProps) => {
  const { texts: allTexts } = useTranslation();
  const { text } = allTexts.component.empty.error;

  return (
    <Empty
      actions={
        retry && (
          <Button onClick={retry} variant="contained" color="primary">
            {<Translate text={allTexts.component.button.common.retry} />}
          </Button>
        )
      }
      text={text}
      {...other}
    />
  );
};

export default Error;
